const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;

import axios from "axios";

const API_ENDPOINT = {
    REGISTER: "/api/tour-player-register",
}

class TourPlayerService {
    send = (data) => {
        const  userLocal = localStorage.getItem('user');
        const user = JSON.parse(userLocal);

        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${user.jwt}`
            }
        };
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.REGISTER, data, config);
    }
}

const tourPlayerService = new TourPlayerService();
export default tourPlayerService;